import React from 'react';

function primaryBlueButton(props){
	return(
		<button type="button" className={" e-primary-blue-btn d-inline-block mr-3 " + props.className} disabled={props.disabled} onClick={props.handleClick}>{props.name}</button>
	)
}

export default primaryBlueButton;